/**
 * List of post endpoints
 */
const ENDPOINT = new Map();

ENDPOINT.set('fetch', '/course/calendar/post/get');
ENDPOINT.set('add', '/course/calendar/post/add');

export default ENDPOINT